import Button from '@jetbrains/ring-ui/components/button/button'
import * as React from 'react'

import {useShowState} from '../AgentPoolPage.hooks'
import type {AgentPool} from '../AgentPoolPage.types'

import EditAgentPoolPopup from './EditAgentPoolPopup/EditAgentPoolPopup'

type Props = {
  agentPool: AgentPool
  className: string
  onUpdate?: () => void
  onRemove?: () => void
}

function EditAgentPoolButton({
  agentPool,
  onUpdate,
  onRemove,
  className,
}: Props): React.ReactElement | null {
  const [show, setShow, setHide] = useShowState()

  const handleUpdate = React.useCallback(() => {
    if (onUpdate != null) {
      onUpdate()
    }
    setHide()
  }, [onUpdate, setHide])

  const handleRemove = React.useCallback(() => {
    if (onRemove != null) {
      onRemove()
    }
    setHide()
  }, [onRemove, setHide])

  return (
    <div className={className}>
      <Button onClick={setShow}>{'Edit pool...'}</Button>
      <EditAgentPoolPopup
        onUpdate={handleUpdate}
        onRemove={handleRemove}
        onClose={setHide}
        hidden={!show}
        agentPool={agentPool}
      />
    </div>
  )
}

export default EditAgentPoolButton
